import { ChangeEvent } from "react";
export const Range = ({scale, setScale}: {scale: number, setScale: (value: number) => void}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setScale(parseInt(e.target.value));
  };

  return (
    <div className="rangeContainer">
      <h3>Heat Scale</h3>
      <input
        type="range"
        id="heatScale"
        name="heatScale"
        min={1}
        max={10}
        value={scale}
        onChange={onChange}
      />
      <div>
        <h4>Sleepers</h4>
        <h4>Heaters</h4>
      </div>
    </div>
  );
};
